export default __webpack_public_path__ + "kate.cb80b692.jpg";